<template>
    <select v-model="selectedLang">
        <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ langNames[lang] }}
        </option>
    </select>
</template>

<script>
    import { ref, watch } from 'vue'
    import { useI18n } from 'vue-i18n'

    const localizedRoutes = {
        '/': {
            en: '/',
            fr: '/fr',
            es: '/es'
        },
        '/faq': {
            en: '/faq',
            fr: '/fr/faq',
            es: '/es/faq'
        },
        '/pricing': {
            en: '/pricing',
            fr: '/fr/pricing',
            es: '/es/pricing'
        },
        '/privacy': {
            en: '/privacy',
            fr: '/fr/privacy',
            es: '/es/privacy'
        },
        '/terms': {
            en: '/terms',
            fr: '/fr/terms',
            es: '/es/terms'
        },
        '/occasions': {
            en: '/occasions',
            fr: '/fr/occasions',
            es: '/es/occasions'
        }
    }

    function canonicalPath(pathname) {
        if (pathname === '/fr' || pathname === '/es') return '/'
        if (pathname.startsWith('/fr/')) return pathname.slice(3)
        if (pathname.startsWith('/es/')) return pathname.slice(3)
        return pathname
    }

    export default {
        name: 'LanguageSelector',
        setup() {
            const { locale } = useI18n()

            const langs = ['en', 'fr', 'es']
            const langNames = {
                en: 'English',
                fr: 'Français',
                es: 'Español'
            }

            const selectedLang = ref(locale.value)

            watch(locale, (newLang) => {
                if (newLang !== selectedLang.value) {
                    selectedLang.value = newLang
                }
            })

            watch(selectedLang, (newLang) => {
                locale.value = newLang
                localStorage.setItem('lang', newLang)
                document.cookie = `lang=${newLang};path=/;max-age=31536000;samesite=strict`

                const routeSet = localizedRoutes[canonicalPath(window.location.pathname)]
                const targetPath = routeSet && routeSet[newLang]
                if (!targetPath || targetPath === window.location.pathname) return

                window.location.href = `${targetPath}${window.location.search || ''}${window.location.hash || ''}`
            })

            return {
                langs,
                langNames,
                selectedLang
            }
        }
    }
</script>

<style scoped>
select {
  height: 38px;
  padding: 0 10px;
  border: 1px solid #d5e4e4;
  border-radius: 10px;
  background-color: white;
  color: #325453;
  font-size: 16px;
  cursor: pointer;
}
</style>
